import { render, staticRenderFns } from "./L03Box3DFlatShading.vue?vue&type=template&id=e6b0fba4&"
import script from "./L03Box3DFlatShading.vue?vue&type=script&lang=js&"
export * from "./L03Box3DFlatShading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports